
import { Messages } from '@tableau/catalog-messages';
import { LabelManagementLink, VisibilityTooltip } from '@tableau/catalog-ui-temp';
import type { OtherDivProps } from '@tableau/vizportalclient-common-components';
import type { RadioButtonWithLabelOption } from '@tableau/widgets';
import { ListItem, RadioButtonWithLabelGroupWidget, TabStyles } from '@tableau/widgets';
import React from 'react';

export function listWithLabelLink(): ListItem[]{
  return [
    {separator: true},
    {value: Messages.labelManagementLink(),
    content: (<LabelManagementLink />) }
  ];
}

export function HelpTextDiv({ disabled, children }: OtherDivProps & { readonly disabled?: boolean }): JSX.Element {
  return <div style={disabled ? { opacity: TabStyles.Opacity.Disabled } : undefined}>{children}</div>;
}

// Warning visibility/severity radio buttons + tooltip
export function SevereWarningContent({ disabled, isSevere, setIsSevere, isLabelValue}: {
  disabled?: boolean;
  isSevere: boolean;
  setIsSevere: (b: boolean) => void;
  isLabelValue?: boolean;
}): JSX.Element | null {
  const title = isLabelValue ? Messages.labelSetDefaultVisibilityLevel() : Messages.labelSetVisibilityLevel();
  const buttonList: RadioButtonWithLabelOption[] = [
    {
      label: <div style={ {marginBottom: '4px'} }>
              <HelpTextDiv>{Messages.labelStandardVisibility()}</HelpTextDiv>
            </div>,
      testId: 'standard',
      value: 'standard',
    },
    {
      label:  <div style={ {marginBottom: '4px'} }>
      <HelpTextDiv>{Messages.labelHighVisibility()}</HelpTextDiv>
    </div>,
      testId: 'severe',
      value: 'severe',
    },
  ];

  return (
    <RadioButtonWithLabelGroupWidget
      removeLeftMargin={true}
      checkedIndex={buttonList.findIndex(b => b.value === (isSevere ? 'severe' : 'standard'))}
      handleChange={!disabled ? (value) => { setIsSevere(value === 'severe'); } : undefined}
      buttonList={buttonList}
      label={
        <div style={ {display:'inline-flex', marginBottom: '6px'} }>
        <HelpTextDiv>
          {title}
          <VisibilityTooltip isLabelValue={isLabelValue} />
        </HelpTextDiv>
        </div>}
      style={{ width: '100%', marginTop: '40px', opacity: disabled ? TabStyles.Opacity.Disabled : undefined }}
      testId={'label-severity-toggle'}
    />
  );
}
